export default __webpack_public_path__ + "dist/media/Down-arrow.9152d6b1.svg";